import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

@Component({
    selector: 'app-exterior-interior-gallery-spot-buttons',
    template: `
        <button
            class="button--minimal exterior-interior-gallery-spot-button"
            [class.exterior-interior-gallery-spot-button--active]="isExterior"
            (click)="exteriorClick.emit()"
        >
            <span class="exterior-interior-gallery-spot-button__text">
                {{'exterior_interior_gallery_spot.exterior' | translate}}
            </span>
        </button>
        <button
            class="button--minimal exterior-interior-gallery-spot-button"
            [class.exterior-interior-gallery-spot-button--active]="!isExterior"
            (click)="interiorClick.emit()"
        >
            <span class="exterior-interior-gallery-spot-button__text">
                {{'exterior_interior_gallery_spot.interior' | translate}}
            </span>
        </button>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExteriorInteriorGallerySpotButtonsComponent {
    @Input() isExterior: boolean;
    @Output() exteriorClick: EventEmitter<void> = new EventEmitter();
    @Output() interiorClick: EventEmitter<void> = new EventEmitter();
    @HostBinding('class') class = 'exterior-interior-gallery-spot__buttons';
}
